"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscribeReducer = void 0;
var UnsubscribeAction_1 = require("@/pages/unsubscribe/actions/UnsubscribeAction");
var UnsubscribeState_init_1 = require("@/pages/unsubscribe/states/UnsubscribeState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.unsubscribeReducer = function (state, action) {
    if (state === void 0) { state = UnsubscribeState_init_1.defaultUnsubscribeState; }
    switch (action.type) {
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onSaveSearchChanged): {
            return __assign(__assign({}, state), { allChecked: !action.payload.state ? false : state.allChecked, savedSearchesSearchSets: state.savedSearchesSearchSets.map(function (it) { return it.userSearchSetId === action.payload.id ? (__assign(__assign({}, it), { notificationEnabled: action.payload.state, notificationChannels: action.payload.state ? [1] : [] })) : it; }) });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onFollowingChanged): {
            return __assign(__assign({}, state), { allChecked: !action.payload.state ? false : state.allChecked, followingsSearchSets: state.followingsSearchSets.map(function (it) { return it.userSearchSetId === action.payload.id ? (__assign(__assign({}, it), { notificationEnabled: action.payload.state, notificationChannels: action.payload.state ? [1] : [] })) : it; }) });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onNewsletterChanged): {
            return __assign(__assign({}, state), { allChecked: !action.payload ? false : state.allChecked, newsletterChecked: action.payload });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onAllNotificationChanged): {
            var checked_1 = action.payload;
            return __assign(__assign({}, state), { newsletterChecked: checked_1, followingsSearchSets: state.followingsSearchSets.map(function (it) { return (__assign(__assign({}, it), { notificationEnabled: checked_1, notificationChannels: checked_1 ? [1] : [] })); }), savedSearchesSearchSets: state.savedSearchesSearchSets.map(function (it) { return (__assign(__assign({}, it), { notificationEnabled: checked_1, notificationChannels: checked_1 ? [1] : [] })); }), allChecked: checked_1 });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onDownloadDataChanged): {
            return __assign(__assign({}, state), { downloadDataChecked: action.payload });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onDeleteCloseClicked): {
            return __assign(__assign({}, state), { deletePopupActive: false });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onDeleteDeleteClicked): {
            return __assign(__assign({}, state), { deletePopupActive: false, confirmPopupActive: true });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onConfirmCloseClicked): {
            return __assign(__assign({}, state), { deletePopupActive: false, confirmPopupActive: false });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.onConfirmDeleteClicked): {
            return __assign(__assign({}, state), { deletePopupActive: false, confirmPopupActive: false });
        }
        case typesafe_actions_1.getType(UnsubscribeAction_1.default.setIsLoading): {
            return __assign(__assign({}, state), { isLoading: action.payload });
        }
        default:
            return state;
    }
};
